/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchNotificationsResponse } from './search-notifications-response';


export interface SearchNotificationsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchNotificationsResponse> | null;
}

